import client from './client/client'
type Method = 'GET' | 'POST' | 'PUT' | 'DELETE'
import { BaseUrl } from './base_url_enum'
import { getStore } from '../state/configure_store'
import { getBaseUrl } from './utils/get_base_url'

// TODO: At some point this should be removed
export interface IApiResponse<T> {
  success: boolean
  status: number
  data: T
  error: string
  message?: string
}

const Api = async <T, B = Record<string, unknown>>(
  method: Method,
  url: string,
  api: BaseUrl,
  params?: B,
  disableCache = false
): Promise<T> => {
  const store = getStore()
  const token = store.getState().token.token?.accessToken

  const { data } = await client(url, {
    baseURL: getBaseUrl(api),
    method,
    // Based on GET or POST set params or data
    ...(method === 'GET' ? { params } : { data: params }),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {})
    }
    // cache: {
    //   enabled: method === 'GET' && !disableCache,
    //   interpretHeader: false, // ignore Cache-Control/Expires from server
    //   cacheTakeover: false
    // }
  })

  return data
}

export default Api
